export const formatCurrency = (value, { maximumFractionDigits } = {}) => {
  const options = {
    style: 'currency',
    currency: 'USD',
  };

  // Opsiyonel: kuruşsuz gösterim (ör. "$1,000"). Verilmezse varsayılan 2
  // basamak korunur. min/max birlikte set edilmeli — aksi halde currency
  // varsayılanı (min 2 > max 0) RangeError fırlatır.
  if (maximumFractionDigits !== undefined) {
    options.maximumFractionDigits = maximumFractionDigits;
    options.minimumFractionDigits = maximumFractionDigits;
  }

  const number = typeof value === 'number' ? value : Number(value);
  const safe = Number.isFinite(number) ? number : 0;

  return Math.abs(safe) < 0.01
    ? (0).toLocaleString('en-US', options)
    : safe.toLocaleString('en-US', options);
};

export const formatPhoneNumber = (phone) => {
  if (!phone) return phone;

  const digits = String(phone).replace(/\D/g, '');
  const local =
    digits.length === 11 && digits.startsWith('1') ? digits.slice(1) : digits;

  if (local.length !== 10) return phone;

  return `(${local.slice(0, 3)}) ${local.slice(3, 6)} ${local.slice(6)}`;
};

export const capitalizeWords = (text) => {
  if (!text) return text;
  return String(text)
    .toLowerCase()
    .replace(/(^|[\s\-'’(/])(\p{L})/gu, (_, sep, ch) => sep + ch.toUpperCase());
};

export const capitalizeSentence = (text) => {
  if (!text) return text;
  return String(text)
    .split(/(\.\s*)/)
    .map((part, idx) => {
      if (idx % 2 === 1) return part;
      return part
        .toLowerCase()
        .replace(/\p{L}/u, (ch) => ch.toUpperCase());
    })
    .join('');
};
